import React from 'react';
import { Button, ButtonProps as MuiButtonProps } from '@material-ui/core';

//spelling attribute in lowercase to pass it as custom attribute in DOM element
export interface CoreButtonProps extends MuiButtonProps {
  title?: string;
  lefticon?: JSX.Element;
  righticon?: JSX.Element;
  background?: string;
  border?: string;
  titlecolor?: string;
  titleclass?: string;
  height?: string;
  padding?: string;
}

const CoreButton: React.FC<CoreButtonProps> = (props): JSX.Element => {
  return (
    <Button {...props}>
      {props.lefticon}
      <div className={props.titleclass}>{props.title}</div>
      {props.righticon}
    </Button>
  );
};

export default CoreButton;
